module.exports = __webpack_public_path__ + "89c84714fbed4f84779ddc7dcc3d61ca.svg";